import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const AdoProjectPickerFieldSchema = makeFieldSchema({
    output: z => z.string(),
    uiOptions: z =>
        z.object({
            secretsKey: z
                .string()
                .describe(
                    'Key used within the template secrets context to store the credential',
                ),
        })
});

export type AdoProjectPickerUiOptions = NonNullable<
    (typeof AdoProjectPickerFieldSchema.TProps.uiSchema)['ui:options']
>;

export type AdoProjectPickerProps = typeof AdoProjectPickerFieldSchema.TProps;

export const AdoProjectPickerSchema = AdoProjectPickerFieldSchema.schema;